import type {
  BackupCodesResponse,
  FactorConfirmedResponse,
  MfaFactorSummary,
  TotpEnrollmentResponse,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const mfaApi = {
  listFactors(): Promise<MfaFactorSummary[]> {
    return apiRequest<MfaFactorSummary[]>('/auth/mfa');
  },

  enrollTotp(): Promise<TotpEnrollmentResponse> {
    return apiRequest<TotpEnrollmentResponse>('/auth/mfa/totp/enroll', { method: 'POST' });
  },

  confirmTotp(credentialId: string, code: string): Promise<FactorConfirmedResponse> {
    return apiRequest<FactorConfirmedResponse>('/auth/mfa/totp/confirm', {
      method: 'POST',
      body: { credentialId, code },
    });
  },

  enrollEmail(): Promise<FactorConfirmedResponse> {
    return apiRequest<FactorConfirmedResponse>('/auth/mfa/email/enroll', { method: 'POST' });
  },

  enrollSms(phoneNumber: string): Promise<{ credentialId: string }> {
    return apiRequest<{ credentialId: string }>('/auth/mfa/sms/enroll', {
      method: 'POST',
      body: { phoneNumber },
    });
  },

  confirmSms(credentialId: string, code: string): Promise<FactorConfirmedResponse> {
    return apiRequest<FactorConfirmedResponse>('/auth/mfa/sms/confirm', {
      method: 'POST',
      body: { credentialId, code },
    });
  },

  regenerateBackupCodes(currentPassword: string): Promise<BackupCodesResponse> {
    return apiRequest<BackupCodesResponse>('/auth/mfa/backup-codes/regenerate', {
      method: 'POST',
      body: { currentPassword },
    });
  },

  disableFactor(credentialId: string, currentPassword: string): Promise<void> {
    return apiRequest<void>(`/auth/mfa/${credentialId}`, {
      method: 'DELETE',
      body: { currentPassword },
    });
  },
};
